import React, { ReactNode, useState, useEffect } from 'react'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'
import { useMediaQuery } from 'react-responsive'
import cx from 'classnames'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Container } from '@quotatisgroup/uikit-public.ui.container'

import './header.scss'

const MOBILE_WIDTH_BREAKPOINT = 1224

export type HeaderProps = {
  children?: ReactNode
  srcLogo?: string
  altLogo?: string
}

function HeaderComponent({ children, srcLogo, altLogo }: HeaderProps) {
  const isTabletOrMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`,
  })
  const [display, setDisplay] = useState(false)

  const [scrollPosition, setSrollPosition] = useState(0)
  const handleScroll = () => {
    setSrollPosition(window.pageYOffset)
  }

  useEffect(() => {
    document.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div
      className={cx('header', {
        fixed: scrollPosition > 30,
      })}
    >
      <Container>
        {isTabletOrMobile ? (
          <Row>
            <div className="side">
              <a href="/" className="logo">
                <Image src={srcLogo} alt={altLogo} />
              </a>
              <div
                className={cx('link-menu', {
                  open: !display,
                  close: display,
                })}
                aria-label="burger menu"
                role="button"
                tabIndex={0}
                onClick={setDisplay.bind(this, !display)}
                onKeyDown={setDisplay.bind(this, !display)}
              />
              <div
                className={cx('content-menu', {
                  open: display,
                  close: !display,
                })}
              >
                {children}
              </div>
            </div>
          </Row>
        ) : (
          <Row>{children}</Row>
        )}
      </Container>
    </div>
  )
}

export const Header = styleProvider(HeaderComponent)
